import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import ListPost from "../components/post/ListPost"
import Banner from "../components/banner/Banner"
import Login from "../components/login/Login"
import NoticeBanner from "../components/notice/NoticeBanner"


const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",

        "@media (min-width: 1334px)": {
            justifyContent: "center",

        },
    },

    LoginNotice: {
        // position: "fixed",
        //  marginLeft: "1300px",
        "@media (max-width: 1000px)": {
            display: "none"
        }

    }
}))
const Posts = () => {

    const style = useStyles();

    return (
        <>
            <div className={style.container}>
                <div>
                    <Banner />
                    <ListPost />
                </div>
                <div className={style.LoginNotice}>
                    <Login />
                    <NoticeBanner />
                </div>
            </div>
        </>
    );
};

export default Posts;